<template>
  <v-container fluid fill-height>
    <v-layout justify-center>
      <v-flex>
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="البحث"
                  single-line
                  hide-details
                  dense
                  class="centered-input"
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="Items"
                :search="search"
                class="elevation-12"
                dense
                item-key="ID"
                height="57vh"
                loading-text="جارٍ التحميل..."
              >
                <template v-slot:item.Status="{ item }">
                  <v-icon
                    :color="item.isActive == true ? '#66BB6A' : '#EF5350'"
                    >{{
                      item.isActive == true
                        ? "mdi-account-check"
                        : "mdi-account-off"
                    }}</v-icon
                  >
                </template>
                <template v-slot:item.Order="{ item }">
                  <v-checkbox
                    @change="ChangeStaus(item)"
                    dense
                    v-model="item.isActive"
                    :label="item.isActive == true ? 'فعال' : 'غير فعال'"
                  ></v-checkbox>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
        <v-snackbar
          transition="fade-transition"
          v-model="snackbar1"
          :timeout="timeout"
        >
          الكمية لا يمكن ان تكون تحت الصفر
        </v-snackbar>
        <v-snackbar
          transition="fade-transition"
          v-model="snackbar2"
          :timeout="timeout"
        >
          الكمية لا يمكن ان تكون تحت الصفر او تساويه
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "UsersTable",
  data() {
    return {
      timeout: 1700,
      snackbar: false,
      snackbar0: false,
      snackbar1: false,
      snackbar2: false,
      search: "",
      Items: [],
      headers: [
        { text: "اسم المستخدم", value: "Username" },
        { text: "اسم الزبون", value: "Custname" },
        { text: "الحالة", value: "Status" },
        { text: "", value: "Order" },
      ],
    };
  },

  created() {
    this.InitItems();
  },

  methods: {
    InitItems() {
      this.$axios.get("Customer").then((result) => {
        console.log(result.data.data);
        this.Items = result.data.data;
        this.Items.forEach((element) => {
          element.Username = element.userName;
          element.Custname = element.name;
          element.Status = element.isActive;
        });
      });
    },
    ChangeStaus(item) {
      this.$axios
        .patch(
          "https://erp.matein3.com/api/Customer/" + item.id + "?status=" + item.isActive
        )
        .then((result) => {
          console.log(result);
        });
    },
  },
};
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
}
</style>
